import { modal_default } from './defaults';
import { Modal } from './types';

export const updateModalState = <K extends keyof Modal>(
  state: Modal,
  key: K,
  data: Partial<Modal[K]>
) => {
  const newState = { ...state };
  newState[key] = { ...newState[key], ...data };
  return newState;
};

export const clearModalState = <K extends keyof Modal>(state: Modal, key: K) => {
  const newState = { ...state };
  newState[key] = modal_default[key] as Modal[K];
  return newState;
};
